module.exports = __webpack_public_path__ + "static/img/SearchDetailRetirement4.543fd24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailRetirement4.png
// module id = 775
// module chunks = 0